import { ApiIntegrationsTable } from "components/Tables/ApiIntegrationsTable/ApiIntegrationsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute, RouteStaticData } from "utils/createTenantFileRoute.ts";
import { getToolScenarioPageItems } from "utils/tenantHeaderItems.ts";

const staticData: RouteStaticData = {
    permissions: [PermissionEnum.ToolIntegration],
    showInSideMenu: true,
    sideMenuParent: "lazy",
    label: "pages.tool.scenario.integration.title"
};

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/"
)({
    component: IntegrationPage,
    staticData,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.scenario.integration.title"),
    }),
});

function IntegrationPage() {
    return (
        <TenantPage headerNavigationItems={getToolScenarioPageItems}>
            <ApiIntegrationsTable />
        </TenantPage>
    );
}

// Delay sideMenuParent after parent route is initialized
import("routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/index.tsx").then((mod) => {
    staticData.sideMenuParent = mod.Route;
});
